import { render, staticRenderFns } from "./ServiceConfig.vue?vue&type=template&id=c1b3ee4c&scoped=true"
import script from "./ServiceConfig.vue?vue&type=script&lang=js"
export * from "./ServiceConfig.vue?vue&type=script&lang=js"
import style0 from "./ServiceConfig.vue?vue&type=style&index=0&id=c1b3ee4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b3ee4c",
  null
  
)

export default component.exports